<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <customer-autocomplete-filter
              :fatherEditedCustomer="filterTpManager"
              :editedCustomerIndex="-1"
              :customerName="'quotation_customer_number'"
              @setFilterCustomer="setFilterCustomer"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_license_plate')"
              v-model="filterTpManager.LicensePlate"
              @input="getTpManager"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="tpManagerDataTableHeaders"
      :items="tpManagerList"
      class="elevation-1 mt-5"
      :loading="isLoadingTpManagerList"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('tp_manager_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="isShowEditTpManagerDialog" fullscreen persistent>
            <!-- <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2 ml-8"
                v-bind="attrs"
                v-on="on"
                :disabled="isAllTextFieldDisable"
              >
                {{ $t('common_new') }}
              </v-btn>
            </template> -->
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_look') }}</span>
                <!-- {{ dialogTitleHeader }} -->
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <!-- <customer-autocomplete
                        :fatherEditedCustomer="editedTpManager"
                        :editedCustomerIndex="-1"
                        :customerName="'quotation_customer_number'"
                        @setCustomer="setCustomer"
                        v-if="editedTpManagerIndex === -1"
                      /> -->
                      <ValidationProvider
                        :name="$t('quotation_customer_number')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedTpManager.CustomerNumber"
                          :label="$t('quotation_customer_number')"
                          :error-messages="errors[0]"
                          disabled
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <ValidationProvider
                        :name="$t('quotation_shortname')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedTpManager.CustomerName"
                          :label="$t('quotation_shortname')"
                          disabled
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <ValidationProvider
                        :name="$t('quotation_full_name')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedTpManager.CustomerFullName"
                          :label="$t('quotation_full_name')"
                          disabled
                          :error-messages="errors[0]"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <ValidationProvider
                        :name="$t('quotation_license_plate')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedTpManager.LicensePlate"
                          :label="$t('quotation_license_plate')"
                          :error-messages="errors[0]"
                          disabled
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <ValidationProvider
                        :name="'TP' + $t('login_account')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedTpManager.Account"
                          label="環保帳號"
                          :error-messages="errors[0]"
                          disabled
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                      <ValidationProvider
                        :name="'TP' + $t('login_password')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="editedTpManager.Password"
                          label="環保密碼"
                          :error-messages="errors[0]"
                          disabled
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-data-table
                :headers="tpRecordDataTableHeaders"
                :items="editedTpManager.TpRecordList"
                class="elevation-1 mt-5  mx-5"
                :loading-text="$t('common_get_data')"
                :no-data-text="$t('common_no_data')"
                :no-results-text="$t('common_no_results')"
                :footer-props="{
                  'items-per-page-options': [30, 50, 100],
                  'items-per-page-text': $t('item_rows_per_page'),
                }"
                :header-props="headerProps"
                :search="searchItem"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>{{ $t('tp_record_title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchItem"
                      append-icon="mdi-magnify"
                      :label="$t('point_search_label')"
                      single-line
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.UpdateTime`]="{ item }">
                  {{ convertToDateTimeFormat(item.UpdateTime) }}
                </template>
                <template v-slot:[`item.RecordType`]="{ item }">
                  {{ turnRecordType(item.RecordType) }}
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedTpManager"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <!-- <v-btn
                  color="green darken-1"
                  text
                  @click="saveEditedTpManager"
                  :loading="isLoadingSaveBtn"
                >
                  {{ $t('common_save') }}
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon @click="isShowEditTpManagerBtn(item)">
          <v-icon small>
            mdi-eye
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpTpManager } from '@/js/http-Manager'
// import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import { RecordType } from '@/js/RecordType'
export default {
  name: 'TpManager',
  components: { CustomerAutocompleteFilter }, // CustomerAutocomplete,
  data: () => ({
    isShowEditTpManagerDialog: false,
    tpManagerList: [],
    editedTpManagerIndex: -1,
    editedTpManager: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      Account: '',
      Password: '',
      TpRecordList: []
    },
    defaultTpManager: {
      CustomerId: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      LicensePlate: '',
      Account: '',
      Password: '',
      TpRecordList: []
    },
    isLoadingTpManagerList: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    totalRows: 0,
    currentOptions: {
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    isUpdateEventTotal: false,
    filterTpManager: {
      CustomerId: '',
      LicensePlate: ''
    },
    searchItem: ''
  }),
  async mounted () {
    this.getTpManager()
  },
  computed: {
    tpManagerDataTableHeaders () {
      return [
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber'
        },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_full_name'), align: 'start', value: 'CustomerFullName' },
        {
          text: this.$t('quotation_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: 'TP' + this.$t('login_account'),
          align: 'start',
          value: 'Account'
        },
        {
          text: 'TP' + this.$t('login_password'),
          align: 'start',
          value: 'Password'
        },
        {
          text: this.$t('common_look'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    tpRecordDataTableHeaders () {
      return [
        {
          text: this.$t('user_username'),
          align: 'start',
          value: 'UserName'
        },
        { text: this.$t('user_nickname'), align: 'start', value: 'NickName' },
        { text: this.$t('common_status'), align: 'start', value: 'RecordType' },
        {
          text: this.$t('installation_notice_time'),
          align: 'start',
          value: 'UpdateTime'
        },
        {
          text: 'TP' + this.$t('login_account'),
          align: 'start',
          value: 'Account'
        },
        {
          text: 'TP' + this.$t('login_password'),
          align: 'start',
          value: 'Password'
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    dialogTitleHeader () {
      return this.editedTpManagerIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    }
  },
  methods: {
    turnRecordType (item) {
      return RecordType.RecordTypeName(item)
    },
    async setFilterCustomer (val) {
      this.filterTpManager.CustomerId = val.Id
      this.filterTpManager = JSON.parse(JSON.stringify(this.filterTpManager))
      await this.getTpManager()
      await this.countTotalRows()
    },
    async setCustomer (val) {
      this.editedTpManager.CustomerId = val.Id
      this.editedTpManager.CustomerNumber = val.Number
      this.editedTpManager.CustomerName = val.ShortName
      this.editedTpManager.CustomerFullName = val.FullName
      this.editedTpManager = JSON.parse(JSON.stringify(this.editedTpManager))
    },
    async getTpManager (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.countTotalRows()
      }
      this.isUpdateEventTotal = true
      this.isLoadingTpManagerList = true
      let param = {
        // 組成一個Obj對應後端值，再回傳給後端
        CustomerId: this.filterTpManager.CustomerId,
        LicensePlate: this.filterTpManager.LicensePlate,
        ItemsPerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy,
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy
      }
      let response = await HttpTpManager.GetTpManager(param)
      this.isLoadingTpManagerList = false
      this.tpManagerList = response.status === 200 ? response.data.Data : []
    },
    async countTotalRows () {
      if (this.isUpdateEventTotal) {
        let param = {
          CustomerId: this.filterTpManager.CustomerId,
          LicensePlate: this.filterTpManager.LicensePlate
        }
        let response = await HttpTpManager.GetTpManagerCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getTpManager(val)
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditTpManagerBtn (item) {
      this.editedTpManagerIndex = this.tpManagerList.indexOf(item)
      this.editedTpManager = JSON.parse(JSON.stringify(item))
      this.isShowEditTpManagerDialog = true
    },
    closeEditedTpManager () {
      this.isShowEditTpManagerDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedTpManager = JSON.parse(JSON.stringify(this.defaultTpManager))
        this.editedTpManagerIndex = -1
      })
    },

    async saveEditedTpManager () {
      // const isValid = await this.$refs.dialogWarrantyPeriod.validate()
      // if (isValid) {
      this.isLoadingSaveBtn = true
      this.isAllTextFieldDisable = true
      this.isLoadingTpManagerList = true

      if (this.editedTpManagerIndex !== -1) {
        await HttpTpManager.UpdateTpManager(this.editedTpManager)
      } else {
        await HttpTpManager.AddTpManager(this.editedTpManager)
      }
      await this.getTpManager()
      await this.countTotalRows()
      this.closeEditedTpManager()
      // }
    }
  }
}
</script>
